import { render } from "./applicat.vue?vue&type=template&id=5d089bf7&scoped=true"
import script from "./applicat.vue?vue&type=script&lang=js"
export * from "./applicat.vue?vue&type=script&lang=js"

import "./applicat.vue?vue&type=style&index=0&id=5d089bf7&lang=less&scoped=true"
import "./applicat.vue?vue&type=style&index=1&id=5d089bf7&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d089bf7"]])

export default __exports__